import script from "./ProductList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductList.vue?vue&type=script&setup=true&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=249ef94d&lang=scss"

const __exports__ = script;

export default __exports__